module.exports = __webpack_public_path__ + "static/img/about-certificate-07.5a4ba62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about-certificate-07.jpg
// module id = tMjc
// module chunks = 1